import {
  Sparkles,
  User,
  Database,
  Building2,
  UserXIcon,
  ClipboardList,
  Plug,
  type LucideIcon,
} from "lucide-react";

export interface SettingsCategory {
  /** URL segment — `/dashboard/settings/<key>`. */
  key: string;
  label: string;
  icon: LucideIcon;
  description: string;
}

/** Settings sections, shared by the settings page and the sidebar nav. */
export const SETTINGS_CATEGORIES: SettingsCategory[] = [
  {
    key: "brand-setup",
    label: "Brand Setup",
    icon: Sparkles,
    description: "Configure brand info and links",
  },
  {
    key: "personal",
    label: "Personal",
    icon: User,
    description: "Your personal preferences",
  },
  {
    key: "data",
    label: "Data",
    icon: Database,
    description: "Extracted and processed information",
  },
  {
    key: "organization",
    label: "Organization",
    icon: Building2,
    description: "General organizational information",
  },
  {
    key: "integrations",
    label: "Integrations",
    icon: Plug,
    description: "Accounts Amy works through",
  },
  {
    key: "exclusion-list",
    label: "Exclusion List",
    icon: UserXIcon,
    description: "Creator to exclude from searches",
  },
  {
    key: "saved-fields",
    label: "Saved Fields",
    icon: ClipboardList,
    description: "Reusable custom CRM fields",
  },
];
